import { Support, Translate } from "aws-sdk";
import configJson from "./Config.json";

const CommonObj = {
  Endpoints: {
    GetCommonDetails: configJson.baseUrl + "/api/Login/GetCommonDetails",
    GetReminderDetails:
      configJson.baseUrl + "/api/LandingPage/GetReminderDetails",
    GetNavigationList:
      configJson.baseUrl + "/api/LandingPage/GetNavigationList",
    GetSideMenuList: configJson.baseUrl + "/api/LandingPage/GetSideMenuList",
    GetSideMenuSubList:
      configJson.baseUrl + "/api/LandingPage/GetSideMenuSubList",
    GetTeamGlanceDetails:
      configJson.baseUrl + "/api/LandingPage/GetTeamGlanceDetails",
    SSOLogout: configJson.baseUrl + "/api/Logout/Revoketoken",
    GetUpcomingHolidayList:
      configJson.baseUrl + "/api/LandingPage/GetUpcomingHolidayList",

    GetCelebrationList:
      configJson.baseUrl + "/api/LandingPage/GetCelebrationList",
  },
  ContentType: {
    Menu: 0,
    Support: 1,
    email: 2,
    copyright: 3,
    query: 4,
    panelheader: 5,
    paneldes: 6,
    chatbot: 7,
    helptext: 8,
    desgination: 9,
    staticmenu: 10,
    exploremenu: 11,
    exploresubmenu: 12,
  },
  Atomicdesign: {
    defaultmaincss:
      "https://atomic-design.rrd.com/ITProjects/HCM/css/library/kendo-default-main-css.css",
    style: "https://atomic-design.rrd.com/ITProjects/HCM/css/style.css",
    component:
      "https://atomic-design.rrd.com/ITProjects/HCM/css/component.css",
    jquery:
      "https://atomic-design.rrd.com/ITProjects/HCM/js/library/jquery.min.js",
    kendo:
      "https://atomic-design.rrd.com/ITProjects/HCM/js/library/kendo.all.min.js",
    kendouilicense:
      "https://atomic-design.rrd.com/ITProjects/HCM/js/library/kendo-ui-license.js",
    componentjs:
      "https://atomic-design.rrd.com/ITProjects/HCM/js/component.js",
  },
  CommonValidationMsg:
    "I'm sorry your requested information can not be processed right now. Please try again later",
  SamplePdfFile:
    "https://atomic-design.rrd.com/ITProjects/MyConnect/troom/img/pdf/samplepdf.pdf",
  Question: "Ask a Question",
  PolicyName: "Policy Center",
  TransactionName: "Quick Access",
  Toast_Types: {
    DELETE: "delete",
    SUCCESS: "success",
    MANDATORY: "mandatory",
    INFO: "info",
  },
};
export default CommonObj;
